import { useParams } from "react-router-dom";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
const BlogDetail = ({ blogs }) => {
  const { blogId } = useParams();
  const blog = blogs[blogId];

  if (!blog) {
    return <p>Blog not found</p>;
  }

  return (
    <div>
      <Navb />
      <div className="container blog-detail text-center">
        <img src={blog.img} alt="blog img" />
        <h1>{blog.title}</h1>
        <p>
          <strong>Date:</strong> {blog.date}
        </p>
        <p>
          <strong>Author:</strong> {blog.author}
        </p>
        <p>{blog.description}</p>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
